export default __webpack_public_path__ + "static/media/a1.610b1a40.png";